// extracted by mini-css-extract-plugin
export default {"root":"AiChat_root__phTEy"};